<template>
  <transition enter-active-class="transition duration-100 ease-out" enter-class="transform scale-95 opacity-0" enter-to-class="transform scale-100 opacity-100" leave-active-class="transition duration-75 ease-in" leave-class="transform scale-100 opacity-100" leave-to-class="transform scale-95 opacity-0">
    <div v-if="toggleModal" class="fixed z-50 sm:absolute left-0 sm:origin-bottom-right sm:left-auto sm:right-0 w-full sm:w-80 bg-white p-2 shadow-lg rounded-lg border border-solid border-neutral-100">
      <ul class="flex flex-col" v-if="isNotEmpty">
        <notification-item v-for="(notification, index) in data" :item="notification" :key="index" @select="onSelect" />
      </ul>
      <div class="p-4 text-center" v-else>
        <span class="w-11 h-11 mx-auto bg-secondary-50 rounded-full flex items-center justify-center mb-2">
          <base-icon name="bell" size="lg" custom="text-secondary-400" />
        </span>
        <h3 class="text-slate-700 text-center">No hay notificaciones pendientes.</h3>
      </div>
      <div class="mt-2">
        <base-button mode="secondary-phantom" text="Cerrar notificaciones" class="w-full" @click="toggle" />
      </div>
      <util-keys @keyup.esc="escDropdown" />
    </div>
  </transition>
</template>

<script>
import NotificationItem from '@/components/NotificationListItem.vue'
import UtilKeys from '@/components/utilities/UtilKeys'
export default {
  name: 'NotificationListModal',
  props: {
    toggleModal: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      require: true
    }
  },
  components: {
    NotificationItem,
    UtilKeys
  },
  computed: {
    isNotEmpty: function () {
      return this.data.length > 0
    }
  },
  methods: {
    toggle: function () {
      this.escDropdown()
    },
    escDropdown: function () {
      this.$emit('toggle')
    },
    onSelect: function (item) {
      this.$emit('select', item)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
